import Typography from '@/ui/components/typography'
import { Link } from 'react-router-dom'

const NotFoundRoute = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <Typography variant="xxl-regular">404 | Not found</Typography>
            <Link to={'/'}>Home</Link>
        </div>
    )
}

export default NotFoundRoute
